import { Icon } from '@/components/icons/Icon'
import { cn } from '@/utils/commonUtil'

import styles from './NoResults.module.scss'

type Props = {
  message?: string
  size?: 'lg'
}

export const NoResults = ({ message = 'No results found!', size }: Props) => (
  <div className={cn(styles.container, { size, styles })}>
    <span className={styles.icon}>
      <Icon name='ghost' />
    </span>
    <p className={styles.message}>{message}</p>
  </div>
)
